import React, { Component } from "react";
import { Button, Input, Row, Col } from "reactstrap";
import LessonCard from "../LessonCard";
import Filter from "../Filter";
export default class LessonItemBank extends Component {
  state = {
    dummyData: [],
    addItemCardData: []
  };
  componentDidMount() {
    let dummyData = [];

    for (let index = 1; index <= 10; index++) {
      dummyData.push({
        index,
        itemCode: `ACT-E-Q${index}`,
        itemType: "Multiple Choice",
        preview: `Oh, king eh? Very nice. 
                            And how'd you get that, 
                            eh? By exploiting the workers. 
                            <span className='underlined_item'>By hanging on to outdated</span> imperialist dogma 
                            which perpetuates the economic and social differences 
                            in our society. If there's ever gonna be any progress...`,
        tags: "hard-question, mess-these-kids-up, questionable-answer",
        nodes: `Writer's Goal`,
        answerChoices: {
          answer001: "Bring out your dead",
          answer002: `Well you can't expect to wield supreme executive power just 'cause some watery tart threw a sword at you!`,
          answer003: `Come back here and take what's coming to you. I'll bite your legs off!`,
          answer004: `All right, all right, not biscuits, but lets kill him anyway.`
        }
      });
    }

    this.setState({
      dummyData: dummyData,
      addItemCardData: dummyData
    });
  }
  itemsFilter = (e, type) => {
    const { dummyData } = this.state;

    e.target.value !== ""
      ? this.setState({
          [type]: dummyData.filter(
            val =>
              val.itemCode
                .toLowerCase()
                .search(e.target.value.toLowerCase()) !== -1
          )
        })
      : this.setState({
          [type]: dummyData
        });
  };
  render() {
    const { addItemCardData } = this.state;

    return (
      <React.Fragment>
        <LessonCard
          iconClass="items-icon"
          heading="Add Items"
          subHeading="Add Items to the Apostrophes Lesson Item Bank"
          isCollapsable={false}
          headerButtons={[
            <Button className={`add-btn`}>+ Create New Item</Button>
          ]}
          footerButtons={[
            <Button className="lesson-cancel-btn" onClick={this.props.onClose}>
              Cancel Changes
            </Button>,
            <Button className="lesson-action-btn">+ Add to Item Bank</Button>
          ]}
        >
          <Filter onChg={e => this.itemsFilter(e, "addItemCardData")} />

          <div className="items-bank-right-container">
            {addItemCardData.map(item => (
              <div className="item">
                <div className="author-lesson-checkbox">
                  <Input type="checkbox" />
                  <span class="checkmark" />
                </div>

                <div className="item-card">
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                      Item Code:
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                      <strong>{item.itemCode}</strong>
                      <a>Edit Item</a>
                      <a onClick={() => console.log("simulate item")}>
                        <i className="screen-eye-icon" />
                      </a>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                      Item Type:
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                      {item.itemType}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                      Preview:
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                      <div dangerouslySetInnerHTML={{ __html: item.preview }} />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                      Tags:
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                      {item.tags}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                      Nodes:
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                      {item.nodes}
                    </Col>
                  </Row>
                </div>
              </div>
            ))}
          </div>
        </LessonCard>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorLesson/AddItems.js